// extracted by mini-css-extract-plugin
export var fullWidth = "header-module--fullWidth--84965";
export var header = "header-module--header--8182f";
export var minimal = "header-module--minimal--cc63a";
export var scrollDown = "header-module--scrollDown--f8b0b";
export var scrolled = "header-module--scrolled--3f89d";
export var showSubnav = "header-module--showSubnav--e6ff7";